import links from "@/links/links";

export default {
  actions: {
    GET_BY_USER_ID(userId) {
      return this.get(links.BUILDING_OWNER_GET_BY_USER_ID(userId), {
        dataKey: "hydra:member",
      });
    },
    FETCH(buildingId) {
      return this.get(links.BUILDING_OWNER_FETCH(buildingId), {
        dataKey: "hydra:member",
      });
    },
    PUT(item) {
      return this.put(links.BUILDING_OWNER_PUT(item.id), item);
    },
    POST(item) {
      return this.post(links.BUILDING_OWNER_POST(), item);
    },
  },
};
